/**
 * src/components/ui/PortalHeader.jsx — the portal's own page header/"nav",
 * per REDESIGN.md's Phase 3 "navigation for each surface" requirement.
 *
 * The portal isn't a multi-page app in the dashboard sense — BookingPortal/
 * FlashGallery/ConsentSign are each a single, mostly linear task a client
 * arrives at from one link (an Instagram bio, an SMS, an email) — so
 * "navigation" here means orienting a nervous first-time visitor to whose
 * booking flow this is and, for a multi-step flow, where they are in it,
 * not a link list. Wraps the step indicator REDESIGN.md's Portal section
 * explicitly allows ("this IS a sequence, so step numbers are legitimate")
 * around the existing `.steps`/`.step` classes in styles.css.
 *
 * Not wired into BookingPortal.jsx/FlashGallery.jsx/ConsentSign.jsx yet —
 * those pages keep their current markup until Phase 4 actually redesigns
 * the portal. Demoed in the component gallery so it's reviewable now.
 */

/**
 * @param {{ studioName: string, step?: { current: number, total: number, label: string } }} props
 * @returns {JSX.Element}
 */
export function PortalHeader({ studioName, step }) {
  return (
    <header className="ui-portal-header">
      <p className="ui-portal-header-brand">{studioName}</p>
      {step ? (
        <nav aria-label="Booking progress" className="steps">
          {Array.from({ length: step.total }, (_, i) => i + 1).map((n) => (
            <span
              key={n}
              className={`step${n === step.current ? ' current' : ''}${n < step.current ? ' done' : ''}`}
              aria-current={n === step.current ? 'step' : undefined}
            >
              {n < step.current ? '✓ ' : ''}
              {n === step.current ? `Step ${n} of ${step.total} — ${step.label}` : n}
            </span>
          ))}
        </nav>
      ) : null}
    </header>
  );
}
